module.exports = __webpack_public_path__ + "media/country_flags/by-afae2d34.png";